import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EquipmentListQuery } from '../../../shared/interfaces/equipment.interfaces';
import { DashEquipmentResponse } from '../../../shared/interfaces/dashboard.interfaces';
import { Subdealer } from '../../../shared/interfaces/dealer.interfaces';

export const DashboardActions = createActionGroup({
  source: 'Dashboard',
  events: {
    'Load Conn Counter': props<{ dealerId?: number | string }>(),
    'Load Conn Counter Success': props<{ data: { [key: string]: number } }>(),

    // Load dashboard statistics (status and signal)
    'Load Dashboard Equipments': props<{ queryParams?: EquipmentListQuery, page?: number }>(),
    'Load Dashboard Equipments Success': props<{ data: DashEquipmentResponse }>(),

    'Unset Dashboard': emptyProps()
  }
});